import service from "./service";

async function getTodoTaskItemId(payload) {
  try {
    const res = await service.getTodoTaskItemId(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function getNextTaskItemId(payload) {
  try {
    const res = await service.getNextTaskItemId(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function getPrevTaskItemId(payload) {
  try {
    const res = await service.getPrevTaskItemId(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function assignTaskItem(payload) {
  try {
    const res = await service.assignTaskItem(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function getWorkspaceInfo(payload) {
  try {
    const res = await service.getWorkspaceInfo(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function getWorkspaceProgressInfo(payload) {
  try {
    const res = await service.getWorkspaceProgressInfo(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function getWorkspacePageInfo(payload) {
  try {
    const res = await service.getWorkspacePageInfo(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function getWorkspaceItems(payload) {
  try {
    const res = await service.getWorkspaceItems(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function getWorkspaceItemDetail(payload) {
  try {
    const res = await service.getWorkspaceItemDetail(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function executeComplete(payload) {
  try {
    const res = await service.executeComplete(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function executeReject(payload) {
  try {
    const res = await service.executeReject(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function executeDelete(payload) {
  try {
    const res = await service.executeDelete(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function updateWorkItemData(payload) {
  try {
    const res = await service.updateWorkItemData(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getOperatorFilter
 * @param {object} payload
 * @param {string} payload.projectId
 * @param {string} payload.taskId
 * @param {string} payload.workType
 * @param {string} payload.scope
 */
async function getOperatorFilter(payload) {
  try {
    const res = await service.getOperatorFilter(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getCommentList
 * @param {object} payload
 * @param {string} payload.taskItemId
 */
async function getCommentList(payload) {
  try {
    const res = await service.getCommentList(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * createComment
 * @param {Object} payload
 * @param {string} payload.taskItemId
 * @param {string} payload.objectId
 * @param {string} payload.objectName
 * @param {string} payload.objectType
 * @param {Array<thread>} payload.threads
 * @param {string} payload.threads.type
 * @param {string} payload.threads.contents
 */
async function createComment(payload) {
  try {
    const res = await service.createComment(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * createThread
 * @param {Object} payload
 * @param {string} payload.taskItemId
 * @param {string} payload.commentId
 * @param {Object} payload.thread
 * @param {string} payload.thread.type
 * @param {string} payload.thread.contents
 */
async function createThread(payload) {
  try {
    const res = await service.createThread(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * solveComment
 * @param {object} payload
 * @param {string} payload.taskItemId
 * @param {string} payload.commentId
 */
async function solveComment(payload) {
  try {
    const res = await service.solveComment(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * unsolveComment
 * @param {object} payload
 * @param {string} payload.taskItemId
 * @param {string} payload.commentId
 */
async function unsolveComment(payload) {
  try {
    const res = await service.unsolveComment(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * postImgSize
 * @param {object} payload
 * @param {string} payload.taskItemId
 * @param {object} payload.imgSize
 */
async function postImgSize(payload) {
  try {
    const res = await service.postImgSize(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function delayTaskItem(payload) {
  try {
    const res = await service.delayTaskItem(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

async function getWorkspaceItemIdList(payload) {
  try {
    const res = await service.getWorkspaceItemIdList(payload);
    checkError(res);
    return res;
  } catch (error) {
    return null;
  }
}

function checkError(res) {
  if (res.status !== 200) {
    prompt(
      `작업공간 서버 응답이 비정상적입니다.\nWorkspace server response is abnormal.\n\n 인풋의 내용의 담당 매니저에게 공유해주세요.\nPlease report the input content to manager.\n\n ${new Date()} ${JSON.stringify(
        res
      )}`,
      `${JSON.stringify(new Date())} ${JSON.stringify(res)}`
    );
  }
}

export default {
  getTodoTaskItemId,
  getNextTaskItemId,
  getPrevTaskItemId,
  assignTaskItem,
  getWorkspaceInfo,
  getWorkspaceProgressInfo,
  getWorkspacePageInfo,
  getWorkspaceItems,
  getWorkspaceItemDetail,
  executeComplete,
  executeReject,
  executeDelete,
  updateWorkItemData,
  getOperatorFilter,
  getCommentList,
  createComment,
  createThread,
  solveComment,
  unsolveComment,
  postImgSize,
  delayTaskItem,
  getWorkspaceItemIdList,
};
